import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { SIDEBAR_CONTENT_OFFSET_VAR } from "src/frontend/components/Shared/NavSidebar/sidebarConstants"

export const APPLICATION_PANE_FULL_WIDTH = 1128
export const GRID_COLUMN_WIDTH = 72

export const APPLICATION_PANE_WIDTH = 744
export const HEADER_HEIGHT = 70
export const HEADER_GAP = 40

export const ApplicationPositioning = styled.div`
  --grid-column-width: ${GRID_COLUMN_WIDTH}px;
  --header-background-color: ${colors.teal};
  --header-text-color: ${colors.white};

  .desktop &,
  .table & {
    --application-pane-width: ${APPLICATION_PANE_WIDTH}px;
    --application-pane-full-width: ${APPLICATION_PANE_FULL_WIDTH}px;
    --header-height: ${HEADER_HEIGHT}px;
    --header-gap: ${HEADER_GAP}px;
    ${SIDEBAR_CONTENT_OFFSET_VAR};

    position: relative;
    height: 100%;
    margin-left: var(--sidebar-content-width);
    width: calc(100vw - var(--sidebar-content-width));
  }

  .mobile-only & {
    --application-pane-width: 100vw;
    --application-pane-full-width: 100vw;
  }
`

export const ApplicationPane = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: var(--application-pane-width);

  .mobile & {
    height: unset;
  }
`

export const ApplicationFullWidthPane = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: var(--application-pane-full-width);
  margin: 0 auto;
`
